import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { id: "page-home" }
const _hoisted_2 = { class: "layout-guide" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { style: {"margin-bottom":"35px"} }
const _hoisted_6 = { class: "layout-s-main" }
const _hoisted_7 = { class: "layout-left" }
const _hoisted_8 = { class: "layout-right" }

import { onBeforeMount } from "vue";
import { NCarousel } from "naive-ui";
import EventsCalendar from "@/components/events-calendar";
import set from "@/components/Set/index.vue";
import title from "@/components/home-title/index.vue";
import banner from "@/components/Banner/index.vue";
import notice from "@/components/notice/index.vue";

interface guide {
  link: string;
  label: string;
  bg: string;
  // keyword: string;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const setsData = [
  {
    title: "全部",
    name: "all",
    id: "7783,7785,7786,7786,7787,7788,7789,7790,7792",
    keyword: "",
  },
  {
    title: "游戏图鉴",
    name: "set2",
    id: "7786",
    keyword: "",
  },
  // {
  //   title: "游戏图鉴",
  //   name: "set2",
  //   id: "7786"
  // },
  // {
  //   title: "玩家投稿",
  //   name: "set7",
  //   id: "7791"
  //   , keyword: ""
  // },
  {
    title: "BOSS介绍",
    name: "set3",
    id: "7787",
    keyword: "",
  },
  {
    title: "版本介绍",
    name: "set4",
    id: "7788",
    keyword: "",
  },
  {
    title: "现金道具",
    name: "set5",
    id: "7789",
    keyword: "",
  },
  {
    title: "玩家投稿",
    name: "set7",
    id: "7783,7785,7786,7786,7787,7788,7789,7790,7792",
    keyword: "玩家投稿",
  },
  // {
  //   title: "其他",
  //   name: "set6",
  //   id: "7792",
  //   keyword: ""
  // },
];

const guideList: Array<guide> = [
  {
    link: "./#/catalog?index=set0",
    // label: "新手指导",
    label: "",
    bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/320510_01.png",
  },
  {
    link: "./#/article?ArticleID=345355",
    // label: "冒险岛世界",
    label: "",
    bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/320510_02.png",
  },
  {
    // link: "./#/article?ArticleID=346281",
    link: "Classes",
    // link: "construction",
    // label: "职业",
    label: "",
    bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/320510_03.png",
  },
  {
    link: "./#/catalog?index=set7",
    // label: "玩家投稿",
    label: "",
    bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/320510_04.png",
  },
];
onBeforeMount(() => {
  // console.log(this);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(guideList, (item, index) => {
        return _createVNode(_component_router_link, {
          key: index,
          to: item.link,
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createElementVNode("div", {
              class: "guide",
              style: _normalizeStyle({ backgroundImage: `url(${guideList[index].bg})` }),
              onClick: navigate
            }, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(item.label), 1)
            ], 12, _hoisted_3)
          ]),
          _: 2
        }, 1032, ["to"])
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(banner), {
        title: "次元站公告",
        icon: "notice"
      }))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(set), {
          setsData: setsData,
          maxLength: "6",
          showMore: true
        }))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(title), {
          title: "活动日历",
          icon: "calendar"
        })),
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(EventsCalendar)))),
        (_openBlock(), _createBlock(_resolveDynamicComponent(notice)))
      ])
    ])
  ]))
}
}

})